module.exports = __webpack_public_path__ + "img/medio9.92b94cb2.jpg";